<template>
  <v-expansion-panels v-model="spanPanels" multiple color="#fff">
    <v-expansion-panel>
      <v-expansion-panel-title
        class="d-flex justify-start"
        hide-actions
        expand-icon="fa-solid fa-plus"
        collapse-icon="fa-solid fa-minus"
      >
        <v-icon v-if="!spanPanels.includes(0)" icon="fa-solid fa-plus" />
        <v-icon v-if="spanPanels.includes(0)" icon="fa-solid fa-minus" />
        <v-row>
          <v-col class="align-left pl-4" cols="4"
            ><h3>Structure Unit ID: {{ span?.strUnitLabel }}</h3></v-col
          >
          <v-col class="align-center" cols="4"
            ><h3>
              Span Type:&nbsp;{{
                span.legacyStructureType
                  ? configStore.getReferenceValue(REFERENCE_TABLE.STRUCTURE_UNIT_TYPE, span.legacyStructureType)
                  : ``
              }}
            </h3></v-col
          >
          <v-col class="align-right pr-4" cols="4"
            ><h3>Unit Key: {{ span?.strUnitKey }}</h3></v-col
          >
        </v-row>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-expansion-panels v-model="spanSubPanels" multiple color="#fff">
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!spanSubPanels.includes(0)" icon="fa-solid fa-plus" />
              <v-icon v-if="spanSubPanels.includes(0)" icon="fa-solid fa-minus" />
              <h3>Span {{ span.strUnitLabel }} Details</h3>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-row class="pl-6">
                <v-col cols="12" lg="6" xl="6" class="pl-0 pb-0 pt-0">
                  <LabelText
                    :id="`${id}_unit_key`"
                    label="SU.01 Unit Key"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :model-value="span?.strUnitKey"
                  /> </v-col
                ><v-col cols="12" lg="6" xl="6" class="pb-0 pt-0">
                  <LabelText
                    :id="`${id}_unit_id`"
                    label="SU.02 Unit ID"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :model-value="span?.strUnitLabel"
                  /> </v-col
              ></v-row>
              <v-row
                ><v-col class="pl-6 pt-0">
                  <LabelText
                    labelXl="12"
                    labelLg="12"
                    labelMd="12"
                    labelSm="12"
                    textXl="12"
                    textLg="12"
                    textMd="12"
                    textSm="12"
                    type="textarea"
                    label="SU.03 Structure Unit Description"
                    :id="`${id}_structure_unit_description`"
                    :counter="255"
                    :maxlength="255"
                    :model-value="span?.strUnitDescription"
                  /> </v-col
              ></v-row>
              <v-row class="pl-6">
                <v-col cols="12" lg="6" xl="6" class="pl-0 pb-0 pt-0">
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_legacy_structure_type`"
                    label="SU.04 Legacy Structure Type"
                    :refTable="REFERENCE_TABLE.STRUCTURE_TYPE"
                    :model-value="span?.legacyStructureType"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_main_set_indicator`"
                    label="SP.02 Main Span Set Indicator"
                    :refTable="REFERENCE_TABLE.MAIN_SPANSET_INDICATOR"
                    :model-value="span?.mainSpanSetIndicator"
                  />
                  <LabelText
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :id="`${id}_config_designation`"
                    label="B.SP.01 Span Config. Designation"
                    :model-value="span?.spanConfigDesignation"
                  />
                  <LabelText
                    :id="`${id}_beam_lines`"
                    label="B.SP.03 Number of Beam Lines"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :counter="null"
                    type="number"
                    :model-value="span?.numberOfBeamLines"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_span_material`"
                    label="B.SP.04 Span Material"
                    :refTable="REFERENCE_TABLE.SPAN_MATERIAL"
                    :model-value="span?.spanMaterial"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_span_Continuity`"
                    label="B.SP.05 Span Continuity"
                    :refTable="REFERENCE_TABLE.SPAN_CONTINUITY"
                    :model-value="span?.spanContinuity"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_span_Type`"
                    label="B.SP.06 Span Type"
                    :refTable="REFERENCE_TABLE.SPAN_TYPE"
                    :model-value="span?.spanType"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_span_Prot_System`"
                    label="B.SP.07 Span Prot. System"
                    :refTable="REFERENCE_TABLE.SPAN_PROTECTION_SYSTEM"
                    :model-value="span?.spanProtectSystem"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_culver_floor_type`"
                    label="SP.15 Culvert Floor Type"
                    :model-value="span?.culvertFloorType"
                    :refTable="REFERENCE_TABLE.CULVERT_FLOOR_TYPE"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_culvert_opening_type`"
                    label="SP.16 Culvert Opening Type"
                    :model-value="span?.culvertOpeningType"
                    :refTable="REFERENCE_TABLE.CULVERT_OPENING_TYPE"
                  />
                  <LabelText
                    :id="`${id}_culvert_length`"
                    label="SP.17 Culvert Length along Centerline"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :counter="null"
                    type="number"
                    appendWith=" ft"
                    :model-value="span?.culvertLengthCenterline"
                  />
                </v-col>
                <v-col cols="12" lg="6" xl="6" class="pb-0 pt-0">
                  <LabelText
                    :id="`${id}_span_length`"
                    label="SP.21 Span Length"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :counter="null"
                    type="number"
                    appendWith=" ft"
                    :model-value="span?.spanLength"
                    :decimalPlaces="2"
                    :roundingFactor="ROUNDING_FACTOR.HUNDRETH"
                  />
                  <LabelCheckbox
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    class="labelCheckbox"
                    :id="`${id}checkbox_span_flared`"
                    label="SP.22 Span Flared"
                    :model-value="span?.spanFlared"
                  ></LabelCheckbox>
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_nstm_Group`"
                    label="SP.03 NSTM Group"
                    :refTable="REFERENCE_TABLE.FC_GROUP_NUMBER"
                    :model-value="span?.nstmGroupNumber"
                  />
                  <v-row>
                    <v-col sm="6" class="pb-0 mb-0"> <v-label class="bold">SP.05 Type of Steel: </v-label></v-col>
                    <v-col class="pl-4 pb-0 mb-0">{{ steelTypeDisplayValue(span?.structureUnitSteelTypes?.map(s => s.steelType)) }}</v-col>
                  </v-row>
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_Dept_Material_Type`"
                    label="SP.24 Dept Material Type"
                    :refTable="REFERENCE_TABLE.MATERIAL_MAKEUP"
                    :model-value="span?.deptMaterialType"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_Dept_Physical_Type`"
                    label="SP.25 Dept Physical Type"
                    :refTable="REFERENCE_TABLE.PHYSICAL_MAKEUP"
                    :model-value="span?.deptPhysicalType"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_Dept_Span_Inter`"
                    label="SP.26 Dept Span Inter"
                    :refTable="REFERENCE_TABLE.SPAN_INTERACTION"
                    :model-value="span?.deptSpanInteraction"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_Dept_Struc_Config`"
                    label="SP.27 Dept Struc Config"
                    :refTable="REFERENCE_TABLE.STRUCTURAL_CONFIGURATION"
                    :model-value="span?.deptStrucConfig"
                  />
                  <LabelText
                    :id="`${id}_min_fill_height`"
                    label="SP.18 Min Fill Height"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :counter="null"
                    type="number"
                    appendWith=" ft"
                    :decimalPlaces="1"
                    :model-value="span?.minFillHeight"
                  />
                  <LabelText
                    :id="`${id}_max_fill_heigth`"
                    label="SP.19 Max Fill Height"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :counter="null"
                    type="number"
                    appendWith=" ft"
                    :decimalPlaces="1"
                    :model-value="span?.maxFillHeight"
                  />
                  <LabelText
                    :id="`${id}_eff_width`"
                    label="SP.20 Hydraulic Opening Eff. Width"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :counter="null"
                    type="number"
                    appendWith=" ft"
                    :decimalPlaces="1"
                    :model-value="span?.hydraulicOpeningEffWidth"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!spanSubPanels.includes(1)" icon="fa-solid fa-plus" />
              <v-icon v-if="spanSubPanels.includes(1)" icon="fa-solid fa-minus" />
              <h3>Culvert Notes</h3>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Top Slab"
                id="field_Top_Slab"
                :inspectionCommentType="INSPECTION_COMMENTS.CULVERT_TOP_SLAB"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Barrel"
                id="field_Barrel"
                :inspectionCommentType="INSPECTION_COMMENTS.CULVERT_BARREL"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Floor/Paving"
                id="field_Floor_Paving"
                :inspectionCommentType="INSPECTION_COMMENTS.CULVERT_FLOOR_PAVE"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Headwall"
                id="field_Headwall"
                :inspectionCommentType="INSPECTION_COMMENTS.CULVERT_HEADWALL"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Wings"
                id="field_Wings"
                :inspectionCommentType="INSPECTION_COMMENTS.CULVERT_WINGS"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Settlement"
                id="field_Settlement"
                :inspectionCommentType="INSPECTION_COMMENTS.CULVERT_SETTLEMENT"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Debris"
                id="field_Debris"
                :inspectionCommentType="INSPECTION_COMMENTS.CULVERT_DEBRIS"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Footing"
                id="field_Footing"
                :inspectionCommentType="INSPECTION_COMMENTS.CULVERT_FOOTING"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.CULVERT"
                label="Combustible Materials Under Bridge"
                id="field__Combustible_Materials_Under_Bridge"
                :inspectionCommentType="INSPECTION_COMMENTS.COMBUSTIBLE_MATERIALS_UNDER_BRIDGE"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span.structureUnitId"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import { computed, ref, watch } from "vue";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { useConfigStore } from "@/stores/config";
import { INSPECTION_COMMENTS, INSPECTION_PAGES } from "@/constants/Inspections";
import StructureUnitCommentTypeTextField from "@/components/inspection/spanBySpanComponents/StructureUnitCommentTypeTextField.vue";
import { useCulvertStore } from "@/components/inspection/store/culvert";
import LabelText from "@/components/common/LabelText.vue";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import { steelTypeDisplayValue } from "@/composables/spanBySpan";

export default {
  name: "CulvertSpanBySpan",
  props: {
    id: { default: null },
    span: { default: null },
    isEditable: { default: false },
    isExpanded: { default: true },
    structureHeader: { default: null },
  },
  setup(props) {
    //Common Code
    const configStore = useConfigStore();
    const culvertStore = useCulvertStore();
    let culvertValue = computed(() => culvertStore.culvertData);

    const spanPanels = ref([0]);

    const spanSubPanels = ref([0, 1]);

    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    watch(
      () => [props.isExpanded],
      () => {
        if (props.isExpanded) {
          spanPanels.value = [0];
        } else {
          spanPanels.value = [];
        }
      },
      { deep: true },
    );

    return {
      configStore,
      steelTypeDisplayValue,
      REFERENCE_TABLE,
      ROUNDING_FACTOR,
      INSPECTION_PAGES,
      culvertValue,
      spanSubPanels,
      spanPanels,
      commentsMaxLength,
      INSPECTION_COMMENTS,
    };
  },
  components: {
    LabelCheckbox,
    LabelSelect,
    LabelText,
    StructureUnitCommentTypeTextField,
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

h3 {
  order: 1;
  color: c.$p-white !important;
}

.v-expansion-panel-title__icon {
  order: 0;
}

.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}

.v-label.v-field-label {
  color: c.$p-black !important;
  opacity: 1 !important;
  font-weight: bold !important;
}
</style>
